module.exports = __webpack_public_path__ + "static/media/unapproved icon.f28d0f15.svg";